import React from "react";

const SuccessIcon = ({ width, height, color }) => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.4957 57.9998C43.5119 57.9998 56.4956 45.0161 56.4956 28.9999C56.4956 12.9837 43.5119 0 27.4957 0C14.7113 0 3.85909 8.27253 0 19.7566C3.64659 10.8252 12.4196 4.53126 22.6626 4.53126C36.1763 4.53126 47.1313 15.4863 47.1313 28.9999C47.1313 42.5136 36.1763 53.4686 22.6626 53.4686C12.4197 53.4686 3.64673 47.1748 8.63212e-05 38.2435C3.85925 49.7274 14.7114 57.9998 27.4957 57.9998Z"
        fill="#39B67B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.0309 17.1544C35.1336 16.4015 33.7958 16.5186 33.0429 17.4159L19.4181 33.6532L13.2158 28.4488C12.3326 27.7078 11.0159 27.823 10.2748 28.7062C9.53374 29.5893 9.64894 30.906 10.5321 31.6471L18.2852 38.1527C18.6795 38.4836 19.1603 38.6438 19.6377 38.6411C20.2887 38.6835 20.9505 38.426 21.402 37.8879L36.2923 20.1424C37.0452 19.2451 36.9282 17.9074 36.0309 17.1544Z"
        fill="#39B67B"
      />
    </svg>
  );
};
export default SuccessIcon;
